import { I18n } from '@calendly/i18n';
import { ArrowChevronDownMiniIcon, ArrowChevronUpMiniIcon } from '@calendly/ui/components/icons';
import { primaryColorL1 } from '@calendly/ui/theme';
import classNames from 'classnames';
import { useState, forwardRef } from 'react';
import { Question } from './question';
import { SectionBody, SectionHeader, WidgetContainer } from './styles';
const iconContainerCss = "i1q6bnqs";
const IconContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(iconContainerCss, props.className)} />;
});
export const RoutingQuestions = ({
  questions
}) => {
  const [expanded, setExpanded] = useState(false);
  if (!questions || questions.length === 0) return null;
  const routingAriaLabel = expanded ? I18n.t('publisher.meeting_intelligence.details.questions.routing_expanded') : I18n.t('publisher.meeting_intelligence.details.questions.routing_collapsed');
  return <WidgetContainer>
      <SectionHeader expanded={expanded} onClick={() => setExpanded(!expanded)} aria-label={routingAriaLabel}>
        {I18n.t('publisher.meeting_intelligence.details.questions.routing_label')}
        <IconContainer>
          {expanded ? <ArrowChevronUpMiniIcon color={primaryColorL1} /> : <ArrowChevronDownMiniIcon color={primaryColorL1} />}
        </IconContainer>
      </SectionHeader>
      {expanded && <SectionBody>
          {questions.map(question => <Question key={question.name} {...question} />)}
        </SectionBody>}
    </WidgetContainer>;
};

require("./routing_questions.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./routing_questions.js");